import { render, staticRenderFns } from "./TrainingPlanBooks.vue?vue&type=template&id=373dd9b4&scoped=true&"
import script from "./TrainingPlanBooks.vue?vue&type=script&lang=js&"
export * from "./TrainingPlanBooks.vue?vue&type=script&lang=js&"
import style0 from "./TrainingPlanBooks.vue?vue&type=style&index=0&id=373dd9b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373dd9b4",
  null
  
)

export default component.exports